import type { SVGProps } from "react";

export default function BarChart(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line x1="28" y1="27.5" x2="3" y2="27.5" stroke="currentColor" />
      <line x1="3.5" y1="3" x2="3.5" y2="28" stroke="currentColor" />
      <rect x="10" y="7" width="2" height="15" fill="currentColor" />
      <rect x="15" y="12" width="2" height="10" fill="currentColor" />
      <rect x="20" y="6" width="2" height="16" fill="currentColor" />
    </svg>
  );
}
